var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpenAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_2571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3231 3.7066C15.1319 2.08027 13.6519 0.853516 11.8806 0.853516C9.98499 0.853516 8.44312 2.29318 8.44312 4.06185V5.52018H3.44312C1.71999 5.52018 0.318115 6.8286 0.318115 8.43685V11.9368C0.318115 13.5451 1.71999 14.8535 3.44312 14.8535H8.44312C10.1662 14.8535 11.5681 13.5451 11.5681 11.9368V8.43685C11.5681 7.24335 10.7956 6.21493 9.69312 5.76402V4.06185C9.69312 2.93602 10.6744 2.02018 11.8806 2.02018C12.9944 2.02018 13.9606 2.81643 14.0806 3.83377C14.1181 4.15402 14.4331 4.38443 14.77 4.35002C15.1131 4.31443 15.3606 4.02685 15.3231 3.7066ZM6.56812 10.7702C6.56812 11.0928 6.28812 11.3535 5.94312 11.3535C5.59812 11.3535 5.31812 11.0928 5.31812 10.7702V9.60352C5.31812 9.28093 5.59812 9.02018 5.94312 9.02018C6.28812 9.02018 6.56812 9.28093 6.56812 9.60352V10.7702Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_2571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white",
    transform: "translate(0.318115 0.853516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenAlt1);
export default __webpack_public_path__ + "static/media/lock-open-alt 1.f38e1e7da9eae6daa3e371f870eeb7fc.svg";
export { ForwardRef as ReactComponent };